import './assets/styles/main.scss';
import InventoryRoutes from './routes';

export default InventoryRoutes;
